










import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class GlobalMenuItem extends Vue {
  @Prop() public to!: string;
  @Prop() public caption!: string;
  @Prop() public selector!: string;
  @Prop({default:null}) public icon?: string;
  @Prop({ default: null }) public svg: string;    
  @Prop({ default: null }) public perm: string;
  @Prop({default:false}) public right:boolean;
  public isActive(path: string) {
    if (path === '/') {
      return this.$route.path === path;
    } else {
      return this.$route.path.startsWith(path);
    }
  }
}
